import styled, { css } from 'styled-components';

const getBlur = (props) => {
  const { width = 0, height = 0 } = props;
  const average = (width + height) / 2;
  return `blur(${Math.ceil(average * 0.01)}px)`;
};
const blurStyles = (props) => {
  if (!props.isLoading || props.placeholder !== "blur")
    return "";
  return css`
    object-fit: contain;
    filter: ${getBlur};
    -webkit-filter: ${getBlur};
    background-size: cover;
    background-image: url("${(props2) => props2.bluredImgURL}");
    background-position: 0% 0%;
    opacity: 1;
  `;
};
const ImageStyled = styled.div`
  width: ${(props) => props.width ? `${props.width}px` : "auto"};
  height: ${(props) => props.height ? `${props.height}px` : "auto"};
  border-radius: 0.4rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .Image {
    &__img {
      max-width: 100%;
      object-fit: contain;
      opacity: ${(props) => props.isLoading ? 0 : 1};
      ${blurStyles}
    }

    &__placeholder {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export { ImageStyled as default };
//# sourceMappingURL=bundle.esm3.js.map
